import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyObject, ErrorMessage } from '@mri/types';
import { getGmtOffset, toDateFormat } from '@mri/functions';

@Component({
  selector: 'app-field-date',
  templateUrl: './field-date.component.html',
  styleUrl: './field-date.component.scss'
})
export class FieldDateComponent {
  private _classSet: Set<string> = new Set<string>();
  private _value: string;

  @Output() valueChange = new EventEmitter<string | Date>;
  @Input() placeholder?: string;

  @Input() set value(value: string) {
    console.log('SetValue', value);
    if (this._isEqualDateValue(value)) return;

    this._value = toDateFormat(new Date(value));

    this._cv.markForCheck();
    this._cv.detectChanges();
  }

  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;
  @Input() image?: string | ((value: string) => string);

  get value(): string {
    const value = this._value;
    if (!value) return '';

    return value;
  }

  get classes(): string {
    return [...this._classSet].join(' ');
  }

  constructor(
    private _cv: ChangeDetectorRef,
  ) {
  }

  onChange(event: AnyObject) {
    const timezone = getGmtOffset();
    const date = event.target.value;
    console.log('OnChange', date);
    this.valueChange.emit(date);
    this._cv.detectChanges();
  }

  onFocus(event: AnyObject) {
    event.target.showPicker();
    this._classSet.add('card-focus');
  }

  onBlur() {
    this._classSet.delete('card-focus');
  }

  private _isEqualDateValue(value: string): boolean {
    const currentValue = this._value;

    if (!currentValue) return false;

    return currentValue === value;
  }
}
